import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'flex-end'
  },

  itemList: {
    marginTop: '-1.25rem !important',
  },
}))

export { useStyles }
